<div class="pod-page" *ngIf="configLoaded && form">

  <form [formGroup]="form" (ngSubmit)="submitForm()" class="pod-form">

    <div class="pod-is-test-checkbox" *ngIf="isAdmin">
      <input
        class="rp-switch"
        id="potest"
        type="checkbox"
        [formControlName]="IS_TEST_FIELD"
        [attr.disabled]="isTestDisabled ? 'disabled' : null"
      >
      <label for="potest">PO test</label>
    </div>

    <div class="pod-sections">
      <div class="pod-saving-overlay" *ngIf="isSubmitting"></div>

      <app-section-general-info
        [form]="form"
        [mode]="mode"
        [sourceType]="sourceType"
        [remoteConfig]="remoteConfig"
        [sourceTypeCatalog]="sourceTypeCatalog"
        [poTypeCatalog]="poTypeCatalog"
        [catalogsLoaded]="catalogsLoaded"
        [submitted]="formSubmitted"
        [fieldConfigs]="sectionFieldConfigs[SECTION.GENERAL_INFORMATION]"
        [lockedSourceType]="lockedSourceType"
        [poLoaded]="poLoaded"
        [poDetail]="poDetail"
        [poBusinessUnitEnabled]="poBusinessUnitEnabled"
        (ownerValidChange)="onOwnerValidChange($event)"
      ></app-section-general-info>

      <app-section-po-document
        [form]="form"
        [mode]="mode"
        [sourceType]="sourceType"
        [remoteConfig]="financesConfig"
        [submitted]="formSubmitted"
      ></app-section-po-document>

      <app-section-budget-dates
        [form]="form"
        [mode]="mode"
        [sourceType]="sourceType"
        [remoteConfig]="remoteConfig"
        [catalogsLoaded]="catalogsLoaded"
        [submitted]="formSubmitted"
        [fieldConfigs]="sectionFieldConfigs[SECTION.BUDGET_AND_DATES]"
        [poId]="poId"
        [poLoaded]="poLoaded"
        [budgetTypeValidationEnabled]="budgetTypeValidationEnabled"
        [tratoExpirationDateEnabled]="tratoExpirationDateEnabled"
      ></app-section-budget-dates>

      <app-section-buyer-info
        *ngIf="isSectionVisibleForSource(SECTION.BUYER_INFORMATION)"
        [form]="form"
        [mode]="mode"
        [sourceType]="sourceType"
        [remoteConfig]="remoteConfig"
        [submitted]="formSubmitted"
        [fieldConfigs]="sectionFieldConfigs[SECTION.BUYER_INFORMATION]"
        [poLoaded]="poLoaded"
        [poDetail]="poDetail"
        (agencyCleared)="agencyExplicitlyCleared = $event"
      ></app-section-buyer-info>

      <app-section-additional-info
        [form]="form"
        [mode]="mode"
        [sourceType]="sourceType"
        [remoteConfig]="remoteConfig"
        [tagsCatalog]="tagsCatalog"
        [catalogsLoaded]="catalogsLoaded"
        [submitted]="formSubmitted"
        [fieldConfigs]="sectionFieldConfigs[SECTION.ADDITIONAL_INFO]"
        [poLoaded]="poLoaded"
      ></app-section-additional-info>
    </div>

    <ng-container *ngIf="mode !== 'edit' || poLoaded">
      <div class="pod-footer" *ngIf="mode === 'edit' && !isDraftEdit">
        <button
          type="button"
          class="rp-button rp-outlined rp-primary"
          [disabled]="isSubmitting"
          (click)="cancelEdit()"
        >
          Cancel
        </button>

        <button
          type="button"
          class="rp-button rp-filled rp-primary"
          [disabled]="!primaryEnabled || isSubmitting"
          (click)="saveChanges()"
        >
          {{ isSubmitting ? 'Saving…' : 'Save changes' }}
        </button>
      </div>

      <div class="pod-footer" *ngIf="mode !== 'edit' || isDraftEdit">
        <button
          type="button"
          class="rp-button rp-outlined rp-primary"
          [disabled]="!saveDraftEnabled || isSubmitting"
          (click)="saveDraft()"
        >
          {{ isSubmitting ? 'Saving…' : 'Save draft' }}
        </button>

        <button
          type="submit"
          class="rp-button rp-filled rp-primary"
          [disabled]="!primaryEnabled || isSubmitting"
        >
          {{ isSubmitting ? 'Saving…' : primaryLabel }}
        </button>
      </div>
    </ng-container>

  </form>

</div>
